module.exports = __webpack_public_path__ + "img/accessory_item_06.3222103c.svg";